// Turns plain "it worked" SweetAlert dialogs into a corner toast that fades out on its own,
// so the user doesn't have to click OK after every save.
//
// Only simple success messages convert: type 'success', short text, and nothing the user has to
// act on (no cancel button, input, HTML body, footer or custom confirm text). Everything else is
// shown as before. A converted call resolves straight away with { value: true }, the same result
// as clicking OK, so code like `.then(() => this.$router.push(...))` carries on immediately.

const MAX_TEXT_LENGTH = 160
const INTERACTIVE_KEYS = ['showCancelButton', 'input', 'html', 'footer', 'confirmButtonText', 'preConfirm', 'inputValidator', 'showLoaderOnConfirm']

function toOptions (args) {
  if (args[0] && typeof args[0] === 'object') return args[0]
  // Positional form: (title, text, type)
  return { title: args[0], text: args[1], type: args[2] }
}

function isSimpleSuccess (options) {
  if (!options || options.type !== 'success') return false
  if (INTERACTIVE_KEYS.some(key => options[key])) return false
  const text = String(options.text || '')
  const title = String(options.title || '')
  return (text + title).length <= MAX_TEXT_LENGTH
}

// vue-sweetalert2 defines this.$swal as a read-only getter, but skips that when $swal already
// exists. So this must run before Vue.use(VueSweetalert2), with the same sweetalert2 build it uses.
export default function installSuccessToasts (Vue, swal) {
  function toastingSwal (...args) {
    const options = toOptions(args)
    if (!isSimpleSuccess(options)) return swal.apply(this, args)
    const title = options.title && options.text ? options.title : (options.title || options.text || 'Done')
    const text = options.title && options.text ? options.text : undefined
    swal({
      toast: true,
      position: 'top-end',
      type: 'success',
      title,
      text,
      showConfirmButton: false,
      timer: 3000,
      customClass: 'nv-toast'
    })
    return Promise.resolve({ value: true })
  }
  // Keep swal.close(), swal.isVisible() and friends working on this.$swal
  Object.getOwnPropertyNames(swal).forEach(key => {
    if (['length', 'name', 'prototype', 'arguments', 'caller'].indexOf(key) !== -1) return
    toastingSwal[key] = swal[key]
  })
  Object.defineProperty(Vue.prototype, '$swal', {
    get () { return toastingSwal },
    configurable: true
  })
}



// WEBPACK FOOTER //
// ./src/plugins/successToasts.js